/**
 * TEMP-DIAG — temporary diagnostics journal for the Driver Build 3 restart
 * investigation. REMOVE this folder (src/debug/) and all `TEMP-DIAG` marked
 * lines in DriverDashboardPage.jsx / DriverLoginPage.jsx before release.
 *
 * Persists to localStorage so entries survive the full WebView reload that
 * `api()` triggers on 401. Only active inside the native Capacitor shell —
 * no-ops on the production website.
 */
const KEY = "t247_diag_journal";
const MAX = 40;

function isNativeShell() {
  try {
    return !!window.Capacitor?.isNativePlatform?.();
  } catch {
    return false;
  }
}

export function logDiag(event, data = {}) {
  if (!isNativeShell()) return;
  try {
    const arr = JSON.parse(localStorage.getItem(KEY) || "[]");
    arr.push({
      seq: arr.length + 1,
      t: new Date().toISOString().slice(11, 23),
      event,
      ...data,
    });
    localStorage.setItem(KEY, JSON.stringify(arr.slice(-MAX)));
  } catch { /* never break the app for diagnostics */ }
}

export function readDiag() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function clearDiag() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}

/** Safe token summary — never logs the full JWT. */
export function tokenFingerprint(token) {
  if (!token) return "MISSING";
  if (token === "undefined" || token === "null") return `LITERAL_STRING:${token}`;
  const kind = token.startsWith("eyJ") ? "jwt" : "NOT_JWT";
  return `${token.slice(0, 10)}...len=${token.length}:${kind}`;
}
